import React from 'react';
import { profile } from '../data';

const Icon = {
  medium: (
    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M13.54 12a6.8 6.8 0 1 1-13.6 0 6.8 6.8 0 0 1 13.6 0zM20.96 12c0 3.54-.76 6.42-1.7 6.42-.94 0-1.7-2.88-1.7-6.42s.76-6.42 1.7-6.42c.94 0 1.7 2.88 1.7 6.42zM24 12c0 3.17-.27 5.75-.6 5.75-.33 0-.6-2.58-.6-5.75s.27-5.75.6-5.75c.33 0 .6 2.58.6 5.75z"/></svg>
  ),
  youtube: (
    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2 31.4 31.4 0 0 0 0 12a31.4 31.4 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1 31.4 31.4 0 0 0 .5-5.8 31.4 31.4 0 0 0-.5-5.8zM9.6 15.6V8.4l6.3 3.6-6.3 3.6z"/></svg>
  ),
  linkedin: (
    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.94v5.67H9.36V9h3.41v1.56h.05a3.74 3.74 0 0 1 3.36-1.85c3.6 0 4.27 2.37 4.27 5.45v6.29zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0z"/></svg>
  ),
  github: (
    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 .3a12 12 0 0 0-3.8 23.4c.6.1.83-.26.83-.58v-2c-3.34.72-4.04-1.6-4.04-1.6-.55-1.4-1.34-1.78-1.34-1.78-1.1-.74.08-.72.08-.72 1.2.08 1.84 1.24 1.84 1.24 1.07 1.84 2.8 1.3 3.5 1 .1-.78.42-1.3.76-1.6-2.66-.3-5.46-1.34-5.46-6 0-1.32.46-2.4 1.24-3.24-.12-.3-.54-1.54.12-3.2 0 0 1-.32 3.3 1.23a11.5 11.5 0 0 1 6 0c2.28-1.55 3.3-1.23 3.3-1.23.66 1.66.24 2.9.12 3.2.78.84 1.24 1.92 1.24 3.24 0 4.66-2.8 5.7-5.48 6 .42.36.8 1.08.8 2.18v3.24c0 .32.22.7.83.58A12 12 0 0 0 12 .3"/></svg>
  ),
  mail: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-10 5L2 7"/></svg>
  ),
};

const Sidebar = () => {
  const { socials } = profile;
  return (
    <aside className="sidebar">
      <div className="avatar">{profile.initials}</div>
      <div className="name">{profile.name}</div>
      <div className="role">{profile.role}</div>
      <div className="location">{profile.location}</div>

      <div className="divider" />

      <div className="socials">
        {socials.medium && (
          <a href={socials.medium} target="_blank" rel="noopener noreferrer" aria-label="Medium" title="Medium">{Icon.medium}</a>
        )}
        {socials.youtube && (
          <a href={socials.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube" title="YouTube">{Icon.youtube}</a>
        )}
        {socials.linkedin && (
          <a href={socials.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" title="LinkedIn">{Icon.linkedin}</a>
        )}
        {socials.github && (
          <a href={socials.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub" title="GitHub">{Icon.github}</a>
        )}
        {profile.email && (
          <a href={`mailto:${profile.email}`} aria-label="Email" title="Email">{Icon.mail}</a>
        )}
      </div>

      <div className="footer">© {new Date().getFullYear()} {profile.name}</div>
    </aside>
  );
};

export default Sidebar;
